export const ACTIVITIES_PER_PAGE = 20;
export const ANNOUNCEMENTS_PER_PAGE = 15;
export const CONTACTS_PER_PAGE = 30;
export const CUSTOMERS_PER_PAGE = 40;
export const LEADS_PER_PAGE = 40;
export const PROJECTS_PER_PAGE = 40;
export const EMPLOYEES_PER_PAGE = 40;
export const PARTNERS_PER_PAGE = 40;
export const SPACES_PER_PAGE = 50;
export const DECISION_TYPE_MATRIX_SIZE = 50;
export const DECISIONS_PER_PAGE = 30;
export const INSTALLMENTS_PER_PAGE = 30;
export const DOCUMENTS_PER_PAGE = 20;

export const MILESTONES_LISTS_PER_PAGE = 20;
export const NEWS_FEED_PER_PAGE = 5;
export const NOTIFICATION_SUBGROUPS_PER_PAGE = 11;
export const SURVEYS_PER_PAGE = 30;
export const TICKETS_PER_PAGE = 30;
export const TODOS_PER_PAGE = 15;
export const TODO_LISTS_PER_PAGE = 10;
export const ASSIGNMENTS_PER_PAGE = 10;
export const EMAIL_EVENTS_PER_PAGE = 100;
export const SESSIONS_PER_PAGE = 100;
export const ISSUES_PER_PAGE = 30;
export const UNITS_PER_PAGE = 30;
export const QUESTIONS_PER_PAGE = 30;
export const QUESTION_LISTS_PER_PAGE = 30;

export const INSPIRATIONS_PER_PAGE = 15;
export const SNIPPETS_PER_PAGE = 15;

export const SURVEY_TYPES_PER_PAGE = 10;

export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 30, 50, 100];

export const PAGINATION_STORAGE_KEYS = Object.freeze({
  ACTIVITY_FEED: 'activity_feed',
  ANNOUNCEMENTS: 'announcements',
  CONTACT_TYPE: 'contact_type',
  CUSTOMER_DASHBOARD_NEWS: 'customer_dashboard_news',
  CUSTOMER_INSTALLMENT_GROUPS: 'customer_installment_groups',
  CUSTOMER_QUESTION_LISTS: 'customer_question_lists',
  CUSTOMER_QUESTIONS: 'customer_questions',
  DECISION_TYPES_MATRIX: 'decision_types_matrix',
  DOCUMENTS: 'documents',
  DOCUMENTS_CATEGORY: 'documents_category',
  DOCUMENTS_FILES: 'documents_files',
  EMAIL_CONVERSATIONS: 'email_conversations',
  INSPIRATIONS: 'inspirations',
  INSTALLMENT_GROUP: 'installment_group',
  INSTALLMENT_GROUPS_LIST: 'installment_groups_list',
  INSTALLMENT_GROUPS_MATRIX: 'installment_groups_matrix',
  ISSUES: 'issues',
  NEWS_FEED: 'news_feed',
  NOTIFICATIONS_SIDEBAR: 'notifications_sidebar',
  OVERVIEW_ALL_PROJECTS: 'overview_all_projects',
  OVERVIEW_DECISIONS: 'overview_decisions',
  OVERVIEW_DOCUMENTS: 'overview_documents',
  OVERVIEW_FAQS: 'overview_faqs',
  OVERVIEW_FINANCIALS: 'overview_financials',
  OVERVIEW_NEWS: 'overview_news',
  OVERVIEW_SURVEYS: 'overview_surveys',
  OVERVIEW_TASKS: 'overview_tasks',
  QUESTION_LISTS: 'question_lists',
  QUESTIONS: 'questions',
  SURVEY_TYPES: 'survey_types',
  SURVEYS: 'surveys',
  TICKETS: 'tickets',
  TODOS_DASHBOARD: 'todos_dashboard',
  TODO_LISTS: 'todo_lists',
});
